import couponTransformer from '../../transformers/coupon';
import instance from './instance';
//lazy but cannot search
export default (query) =>
  instance()
    .get('/coupons', { params: query || {} })
    .then(({ data: { data, totalCount } }) => {
      let dataRes = { data: null, totalCount };
      if (data) {
        dataRes.data = couponTransformer.fetchCollectionForTable(data);
      }
      return dataRes;
    })
    .catch((err) => err);
